import Logo from "../../atoms/logo/logo";

const Header = () => (
  <div className="d-flex flex-row w-100 justify-content-center mt-5 position-absolute">
    <Logo />
  </div>
)

export default Header;